"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
function BannerBox({ text, type, dataCy, customClass, action, children, iconClass, withIcon = true, iconSize = 20, paddingClass = 'px-[16px] py-[16px]', marginClass = 'mb-[16px]', alignItemsClass = 'items-center', borderRadiusClass = 'rounded' }) {
    let backgroundColor;
    let icon = '';
    let fillColor;
    const bannerCN = (0, classnames_template_literals_1.default)(`
    flex justify-start items-start
    min-h-[40px]
    animate-fadein
    ${marginClass}
    ${paddingClass}
    ${alignItemsClass}
    ${borderRadiusClass}
    ${customClass && customClass}
  `);
    switch (type) {
        case 'neutral':
            backgroundColor = 'var(--n-300)';
            icon = 'icon-info';
            fillColor = 'var(--n-600)';
            break;
        case 'info':
            backgroundColor = 'var(--b-200)';
            icon = 'icon-info';
            fillColor = 'var(--b-600)';
            break;
        case 'warning':
            backgroundColor = 'var(--y-200)';
            icon = 'icon-warning';
            fillColor = 'var(--y-600)';
            break;
        case 'confirmation':
            backgroundColor = 'var(--g-200)';
            icon = 'icon-check_circle';
            fillColor = 'var(--g-600)';
            break;
        case 'error':
            backgroundColor = 'var(--r-200)';
            icon = 'icon-warning';
            fillColor = 'var(--r-600)';
            break;
        default:
            break;
    }
    return (react_1.default.createElement("div", { "data-cy": dataCy, className: bannerCN, style: { backgroundColor: backgroundColor } },
        withIcon && (react_1.default.createElement(SVGIcon_1.default, { size: iconSize, iconName: icon, fillColor: fillColor, customClass: `${iconClass ? iconClass : 'mr-[16px]'}` })),
        react_1.default.createElement("div", { className: "flex justify-between items-center w-full" },
            react_1.default.createElement("p", { className: "mb-[0px] typography-paragraph text-n-900 leading-[24px] w-full" },
                ' ',
                children || text,
                ' '),
            action && (react_1.default.createElement("span", { className: "typography-link cursor-pointer whitespace-nowrap", onClick: (e) => {
                    e.stopPropagation();
                    action.onClick();
                } }, action.text)))));
}
exports.default = BannerBox;
